import { FC, useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Collapse,
  Box,
  Stack,
  Divider,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { successGreen } from '@styles/colors';

type SurveySingleCardProps = {
  item: {
    icon: string;
    title: string;
    description: string;
    isActive: boolean;
    action: () => void;
  };
};

const SurveySingleCard: FC<SurveySingleCardProps> = ({ item }) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 5,
        maxWidth: 300,
        margin: 'auto',
        mt: 4,
        position: 'relative',
      }}
    >
      {item.isActive && (
        <Box
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
          }}
        >
          <CheckCircleIcon sx={{ fill: successGreen }} />
        </Box>
      )}
      <CardContent>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Stack
            sx={{ cursor: 'pointer' }}
            alignItems="center"
            onClick={item.action}
          >
            <img
              src={item.icon}
              alt={item.title}
              style={{
                width: '50px',
                height: '50px',
                objectFit: 'cover',
                marginBottom: '8px',
              }}
            />
            <Typography variant="h6" gutterBottom>
              {item.title}
            </Typography>
          </Stack>
          <Divider sx={{ width: '100%' }} />
          <Button size="small" onClick={handleToggle} sx={{ mt: 1 }}>
            {expanded ? 'Hide Details' : 'Details'}
          </Button>
        </Box>
        <Collapse in={expanded}>
          <Box mt={2}>
            <Typography variant="body2">{item.description}</Typography>
          </Box>
        </Collapse>
      </CardContent>
    </Card>
  );
};

export default SurveySingleCard;
